import axios from 'axios';

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || 'http://127.0.0.1:8000/api',
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
});

// Request interceptor to automatically attach authorization header
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle session expiration, unauthorized requests, or maintenance mode
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      if (error.response.status === 401) {
        // Clear expired credentials
        localStorage.removeItem('access_token');
        localStorage.removeItem('user_profile');
        
        // Auto redirect to login page (preserving clean routes via client history router)
        if (!window.location.pathname.endsWith('/login') && !window.location.pathname.endsWith('/auth/callback')) {
          window.location.href = '/login';
        }
      } else if (error.response.status === 503) {
        // Auto redirect to maintenance page
        if (!window.location.pathname.endsWith('/maintenance')) {
          window.location.href = '/maintenance';
        }
      }
    }
    return Promise.reject(error);
  }
);

export default api;
